module.exports = __webpack_public_path__ + "img/3-3-2-4.efc200c8.png";